//审核申请详情
<template>
	<Page :showReturn="true">
		<el-button class="exportBtn" type="primary" size="mini" @click="handleExportPdf" v-loading="exportLoading"
			v-if="fromPage === 'myAudit' || fromPage === 'myApply'">
			导出申请单据
		</el-button>
		<AuditHeader slot="auditHeader" v-show="showReject" :applyResult="applyResult" />
		<div ref="pdfHtml" class="pdfHtml" :style="exportLoading ? 'width:794px' : ''">
			<!-- 动态详情组件 -->
			<component :is="detailComponent" v-bind="detailComponentProps" @export="handleExport"
				@downloadFile="downloadFile" />
			<!-- 审批流程和备注 -->
			<AuditProcess v-if="fromPage != 'myDevice' && fromPage != 'orderQuery'"
				:processInstanceIdInfo="processInstanceIdInfo" :remarks="remarks" @addRemark="remarkVisible = true"
				@openPdf="openPdf" />
		</div>
		<template slot="bottom" v-if="auditStatus">
			<el-button type="danger" @click="toEdit()" v-if="update">
				编辑
			</el-button>
			<el-button type="primary" @click="checkVisible = true; auditType = 1">
				审核通过
			</el-button>
			<el-button type="warning" @click="checkVisible = true; auditType = 2">
				驳回
			</el-button>

			<el-button type="danger" @click="checkVisible = true; auditType = 3" v-if="rollback">
				回退
			</el-button>
			<el-button type="danger" @click="checkVisible = true; auditType = 4" v-if="transfer">
				转签
			</el-button>
		</template>
		<DialogCheck @updateList="getData" @error="error" @back="backEvent" :auditType="auditType"
			:processInstanceId="processInstanceId" :taskId="taskId" v-if="checkVisible" :visible.sync="checkVisible" />
		<DialogRemark v-if="remarkVisible" :visible.sync="remarkVisible" :currentItem="processCode"
			@refreshRemark="listRemark" />
		<!--  //服务配件归还申请、 服务收费单、设备形态转换申请、领料申请 审核通过前判断数量能否审核 失败提示弹窗 -->
		<el-dialog :destroy-on-close="true" :close-on-click-modal="false" title="提示" :visible.sync="showError"
			append-to-body width="800px" v-loading="loading">
			<div style="font-weight: bold; font-size: 16px; margin-bottom: 12px">
				{{
					type == 3
						? '服务工程师货位无此存货数量，无法完成归还申请，请联系服务工程师确认。'
						: '产品在u8系统库存不足，无法完成申请。请先在u8系统补充产品库存。'
				}}
			</div>
			<el-table border :data="errorTableList" v-loading="loading" height="400px">
				<el-table-column header-align="center" show-overflow-tooltip prop="msg" label="错误信息" />
			</el-table>

			<span slot="footer" class="dialog-footer">
				<el-button @click="showError = false">关闭</el-button>
			</span>
		</el-dialog>
		<!-- 通用导出弹窗 -->
		<ExportDialog :visible.sync="exportDialogVisible" :title="exportDialogTitle" :fileName="exportFileName"
			@open="handleExportDialogOpen">
			<!-- 导出内容 -->
			<DetailType41Export v-if="type === 41" :orderResult="exportContentProps.orderResult"
				:detailResults="exportContentProps.detailResults" />
		</ExportDialog>
	</Page>
</template>

<script>
import AuditHeader from './components/AuditHeader.vue'
import AuditProcess from './components/AuditProcess.vue'
import DetailType0 from './components/DetailType0.vue'
import DetailType1 from './components/DetailType1.vue'
import DetailType3 from './components/DetailType3.vue'
import DetailType4 from './components/DetailType4.vue'
import DetailType41 from './components/DetailType41.vue'
import DetailType41Export from './components/DetailType41Export.vue'
import DetailType5 from './components/DetailType5.vue'
import DetailType6 from './components/DetailType6.vue'
import DetailType7 from './components/DetailType7.vue'
import DetailType8 from './components/DetailType8.vue'
import DialogRemark from './components/DialogRemark.vue'
import DialogCheck from './components/DialogCheck.vue'
import ExportDialog from './components/ExportDialog.vue'
import {
	exportPdf2
} from '@/utils/htmlToPdf'
export default {
	components: {
		AuditHeader,
		AuditProcess,
		DetailType0,
		DetailType1,
		DetailType3,
		DetailType4,
		DetailType41,
		DetailType5,
		DetailType6,
		DetailType7,
		DetailType8,
		DialogRemark,
		DialogCheck,
		ExportDialog,
		DetailType41Export
	},
	data() {
		return {
			fromPage: '',
			auditable: false,
			checkVisible: false,
			remarkVisible: false,
			showReject: false,
			applyResult: {},
			type: '', //业务类型
			orderCode: '',
			processCode: '',
			orderResult: {},
			detailResults: [],
			processInstanceIdInfo: {},
			auditStatus: false,
			processInstanceId: '',
			taskId: '',
			showError: false,
			errorTableList: [],
			remarks: [], // 备注列表
			exportLoading: false,
			editUrl: '', // 修改地址
			exportDialogVisible: false, // 导出弹窗显示状态
			exportDialogTitle: '导出单据', // 导出弹窗标题
			exportFileName: '', // 导出文件名
			exportDialogHasOptions: false, // 是否有导出选项
			exportContentComponent: null, // 导出内容组件
			exportContentProps: {}, // 导出内容组件props
			exportWithNotes: true // 是否包含备注（用于维修清单）
		}
	},
	computed: {
		nickname() {
			let nickname = this.$store.state.userInfo?.nickname
			return nickname
		},
		update() {
			let node = (this.processInstanceIdInfo?.nodes || []).find(item => item?.auths?.length > 0 && item
				.status === 1)
			return node
		},
		rollback() {
			let node = (this.processInstanceIdInfo?.nodes || []).find(item => item.rollback === 1 && item.status !== 2)
			return node
		},
		transfer() {
			let node = (this.processInstanceIdInfo?.nodes || []).find(item => item.transfer === 1 && item.status !== 2)
			return node
		},
		// 动态组件映射
		detailComponent() {
			const componentMap = {
				0: 'DetailType0',
				1: 'DetailType1',
				11: 'DetailType1',
				2: 'DetailType1',
				21: 'DetailType1',
				3: 'DetailType3',
				4: 'DetailType4',
				41: 'DetailType41',
				5: 'DetailType5',
				6: 'DetailType6',
				7: 'DetailType7',
				71: 'DetailType7',
				8: 'DetailType8'
			}
			return componentMap[this.type] || null
		},
		// 动态组件props
		detailComponentProps() {
			const baseProps = {
				type: this.type,
				applyResult: this.applyResult,
				orderResult: this.orderResult,
				detailResults: this.detailResults,
				showExportBtn: this.showExportBtn,
				exportLoading: this.exportLoading,
				nickname: this.nickname
			}
			return baseProps
		},
		showExportBtn() {
			return this.fromPage === 'myAudit' || this.fromPage === 'myApply'
		}
	},
	created() {
		this.type = Number(this.$route.query.type)
		this.fromPage = this.$route.query.from
		this.processInstanceId = this.$route.query.processInstanceId
		this.getData()
	},
	methods: {
		toEdit() {
			if (!this.update || !this.editUrl) {
				this.$message.warning('该类型暂不支持编辑')
				return
			}
			this.$router.push({
				path: this.editUrl,
				query: {
					orderCode: this.orderCode,
					auths: this.update.auths.join(','),
					edit: 1
				}
			})
		},
		openPdf(url) {
			window.open(url)
		},
		exportPdfHtml() {
			this.$nextTick(() => {
				if (!this.orderResult.orderCode) {
					this.$message.warning('暂无数据，无法导出')
					return
				}
				// 其他类型使用原有逻辑
				const $pdfHtml = this.$refs.pdfHtml
				if ($pdfHtml) {
					this.exportLoading = true
					this.$nextTick(async () => {
						await this.$utils.wait(1000)
						let time = this.$utils.dateFormat(
							this.orderResult.applyTime || this.orderResult.createTime,
							'YYYY-mm-dd'
						)
						let typeName =
							this.$constant.applyType.find(a => a.value === this.type)
								?.label || ''
						let fileName =
							(this.orderResult.proposerName || this.nickname) +
							typeName +
							'单' +
							time
						exportPdf2(fileName, $pdfHtml, () => {
							this.exportLoading = false
						})
					})
				} else {
					this.$message.warning('找不到目标元素，无法导出')
				}
			})
		},
		error(data) {
			this.showError = true
			this.errorTableList = data
		},
		async getData() {
			try {
				this.loading = true
				const {
					processInstanceId,
					processCode
				} = this.$route.query
				this.processCode = processCode
				let applyResult = await this.$api.apply.applyResult({
					processCode
				})
				applyResult.statusStr =
					(applyResult.invalidating == 1 ? '作废' : '') +
					this.$constant.auditStatus.find(a => a.value == applyResult.status)
						?.label
				this.applyResult = applyResult
				this.orderCode = applyResult.orderCode
				let res
				switch (this.type) {
					case 0:
						res = await this.$api.apply.faultRepairInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/maintainApply'
						break
					case 11:
					case 1:
						res = await this.$api.apply.standByApplyInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/standByApply'
						break
					case 21:
					case 2:
						res = await this.$api.apply.partsApplyInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/partsApply'
						break
					case 3:
						res = await this.$api.apply.partsReturnInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/partsReturnApply'
						break
					case 4:
						res = await this.$api.apply.sellOrderInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/sellOrderApply'
						break
					case 41:
						res = await this.$api.apply.sellOrderInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/newSellOrderApply'
						break
					case 5:
						res = await this.$api.apply.convertInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/convertApply'
						break
					case 6:
						res = await this.$api.apply.storageOrderInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/storageOrderApply'
						break
					case 71:
					case 7:
						res = await this.$api.apply.pickingOrderInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/pickingOrderApply'
						break
					case 8:
						res = await this.$api.apply.invoiceOrderInfo({
							orderCode: this.orderCode
						})
						this.editUrl = '/invoiceApply'
						break
				}
				if (!res) {
					this.$message.warning('没有找到该类型的详情')
					return
				}
				try {
					const unreadNum = await this.$api.workOrder.readDataByOrderCode({
						orderCode: this.processCode
					})
					this.$utils.refreshData(unreadNum)
				} catch (e) {
					console.log(e)
				}
				this.orderResult = res.orderResult || res.sellOrderResult || {}
				this.detailResults = res.detailResults || []

				this.showReject =
					this.applyResult.status == 2 || this.applyResult.status == 3 || this.applyResult
						.invalidating == 1

				if (processInstanceId) {
					//获取审核数据
					this.processInstanceIdInfo =
						await this.$api.flowable.listAssignedUsers({
							processInstanceId: processInstanceId
						})
					if (this.fromPage == 'myAudit' || this.fromPage == 'msgNotice') {
						const {
							list,
							total
						} = await this.$api.apply.getAudit({
							status: 0,
							processInstanceId: processInstanceId,
							pageNo: 1,
							pageSize: 1
						})
						this.auditStatus = total > 0
						if (this.auditStatus) {
							this.taskId = list[0].taskId
							this.showReject = false
						}
					} else {
						this.auditStatus = false
					}
				}
				// 查询备注
				await this.listRemark()
			} catch (err) {
				console.log(err)
			} finally {
				this.loading = false
			}
		},
		async listRemark() {
			let remarks = await this.$api.apply.listRemark({
				orderCode: this.processCode
			})
			const _this = this
			this.remarks = remarks.map(item => {
				if (item.imgUrls) {
					let imgUrls = item.imgUrls
						.filter(url => !url.includes('.pdf'))
						.map(url => {
							return _this.interceptImg(url)
						})
					let pdfs = item.imgUrls
						.filter(url => url.includes('.pdf'))
						.map(url => {
							return _this.interceptImg(url)
						})
					return {
						...item,
						imgUrls,
						pdfs
					}
				} else {
					return item
				}
			})
		},
		async handleExport() {
			switch (this.type) {
				case 0:
					await this.$api.apply.exportFaultRepairInfo({
						orderCode: this.orderCode
					})
					break
				case 1:
				case 11:
					await this.$api.apply.exportStandByApplyInfo({
						orderCode: this.orderCode
					})
					break
				case 2:
				case 21:
					await this.$api.apply.exportPartsApplyInfo({
						orderCode: this.orderCode
					})
					break
				case 3:
					await this.$api.apply.exportPartsReturnInfo({
						orderCode: this.orderCode
					})
					break
				case 4:
				case 41:
					await this.$api.apply.exportSellOrderInfo({
						orderCode: this.orderCode
					})
					break
				case 5:
					await this.$api.apply.exportConvertInfo({
						orderCode: this.orderCode
					})
					break
				case 6:
					await this.$api.apply.exportStorageOrderInfo({
						orderCode: this.orderCode
					})
					break
				case 7:
				case 71:
					await this.$api.apply.exportPickingOrderInfo({
						orderCode: this.orderCode
					})
					break
				case 8:
					await this.$api.apply.exportInvoiceOrderInfo({
						orderCode: this.orderCode
					})
					break
			}
		},
		downloadFile() {
			let url = (name = this.orderResult.attachmentUrl)
			if (this.orderResult.attachmentUrl.includes('?fileName=')) {
				url = this.orderResult.attachmentUrl.split('?fileName=')[0]
				name = this.orderResult.attachmentUrl.split('?fileName=')[1]
			}

			this.$utils.openDownload(url, name)
		},
		handleExportPdf() {
			if (!this.orderResult.orderCode) {
				this.$message.warning('暂无数据，无法导出')
				return
			}
			// 如果是type 41，使用导出弹窗
			if (this.type === 41) {
				this.exportWithNotes = true
				const time = this.$utils.dateFormat(
					this.orderResult.applyTime || this.orderResult.createTime || this.orderResult.orderTime,
					'YYYY-mm-dd'
				)
				this.openExportDialog({
					fileName: `服务收费单_${this.orderResult.orderCode}`,
					hasOptions: true,
					props: {
						orderResult: this.orderResult,
						detailResults: this.detailResults,
						showNotes: this.exportWithNotes
					}
				})
			} else {
				// 其他类型使用原有逻辑
				this.exportPdfHtml()
			}
		},
		// 打开导出弹窗（通用方法）
		openExportDialog(config = {}) {
			// 设置导出配置
			this.exportDialogTitle = config.title || '导出申请单据'
			this.exportFileName = config.fileName || ''
			this.exportDialogHasOptions = config.hasOptions || false
			this.exportContentComponent = config.component || null
			this.exportContentProps = config.props || {}
			this.exportDialogVisible = true
		},
		// 导出弹窗打开时的处理
		handleExportDialogOpen() {
			// 可以在这里做一些初始化操作
		},
		backEvent() {
			this.$router.back()
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .el-timeline-item__content {
	div {
		margin-bottom: 10px;
	}
}

.remark {
	width: 100%;

	.title {
		display: flex;
		justify-content: space-between;
		padding: 5px 10px;
	}

	.content {
		padding: 5px;
		margin: auto 10px;
		border: 1px solid #ddd;
		border-radius: 5px;

		.img {
			width: 100px;
			height: 100px;
			padding: 2px 5px 2px 0;
		}
	}
}

/deep/ .page-content {
	position: relative;
}


/deep/ .repair-list-dialog {
	.el-dialog__body {
		padding: 20px;
		max-height: 70vh;
		overflow-y: auto;
	}
}

.repair-list-content {
	background: #fff;
	position: relative;
}

.exportBtn {
	position: absolute;
	right: 0;
	top: 12px;
	z-index: 1;
}
</style>